import { Route, Switch } from 'react-router-dom';

import SideMenu from '../../components/SideMenu/SideMenu'

import Border from './components/Border'
import Flex from './components/Flex';
import Image from './components/Image';
import Margin from './components/Margin';
import Padding from './components/Padding'
import Overflow from './components/Overflow'
import Shadow from './components/Shadow'
import Round from './components/Round';
import Rotate from './components/Rotate';
import Height from './components/Height';

const DUMMY_LINKS = [
    { content: 'Border', url: '/misc/border' },
    { content: 'Padding', url: '/misc/padding' },
    { content: 'Margin', url: '/misc/margin' },
    { content: 'Flex', url: '/misc/flex' },
    { content: 'Height', url: '/misc/height' },
    { content: 'Rotate', url: '/misc/rotate' },
    { content: 'Rounded', url: '/misc/rounded' },
    { content: 'Shadow', url: '/misc/shadow' },
    { content: 'Overflow', url: '/misc/overflow' },
    { content: 'Image', url: '/misc/image' },
]

const Misc = () => {

    const changeCssCls = (id, content, css, event) => {

        /* console.log("ID: " + id);
        console.log("CONTENT: " + content);
        console.log("CSS: " + css);
        console.log("EVENT: " + event); */

        // console.log(event.target.value);

        let e = '';
        if (event) {
            e = ' ' + event.target.value
        }

        if (Array.isArray(id)) {

            id.forEach(idd => {
                if (content === 'flex-property') {
                    if (idd === 'flex-display-column') {
                        document.getElementById(idd).className = 'column ' + css + e
                    } else {
                        document.getElementById(idd).className = 'row ' + css + e
                    }
                } else {
                    document.getElementById(idd).className = css + e
                }
            })
        } else {
            document.getElementById(id).className = css + e
            content && (document.getElementById(id).innerHTML = content)
        }
    }

    return <div className='container xxl py-3'>
        <div className='row'>
            <div className='col md-I order-last menu-column'>
                <SideMenu links={DUMMY_LINKS} />
            </div>
            <div className='col md-V content-column'>

                <Switch>
                    <Route path='/misc' exact render={() => <Border helper={(changeCssCls)} />} />
                    <Route path='/misc/border' exact render={() => <Border helper={(changeCssCls)} />} />
                    <Route path='/misc/padding' exact render={() => <Padding helper={(changeCssCls)} />} />
                    <Route path='/misc/margin' exact render={() => <Margin helper={(changeCssCls)} />} />
                    <Route path='/misc/flex' exact render={() => <Flex helper={(changeCssCls)} />} />
                    <Route path='/misc/image' exact render={() => <Image helper={(changeCssCls)} />} />
                    <Route path='/misc/overflow' exact render={() => <Overflow />} />
                    <Route path='/misc/shadow' exact render={() => <Shadow helper={(changeCssCls)} />} />
                    <Route path='/misc/rounded' exact render={() => <Round helper={(changeCssCls)} />} />
                    <Route path='/misc/rotate' exact render={() => <Rotate helper={(changeCssCls)} />} />
                    <Route path='/misc/height' exact render={() => <Height helper={(changeCssCls)} />} />
                </Switch>

            </div>
        </div>
    </div>
}

export default Misc